
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import ClipboardJS from 'clipboard'
import {getUserInfo,ptlogin} from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
userInfo: {},
msg: "",
show: false,
lang: "zh",
password: "",
username: "",
setInfo: {},
ptlogin: {}
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()

this.lang = window.localStorage.getItem('lang')
this.username = window.localStorage.getItem('username')
this.password = window.localStorage.getItem('password')
this.getData()
this.getSetInfo()
},
methods:{
...mapMutations(['SETTOKEN',"CLEAN_ALL"]),
getSetInfo(){
var that = this
ptlogin().then(function(res){
var res = res.data;
that.setInfo = res.data
}.bind(this),function(){
console.log("error")
})
},
copyCode () {
let clipboard = new ClipboardJS('.code-copy-btn')
clipboard.on('success', (e) => {
this.sendMsg(this.$t('复制成功'))
})
clipboard.on('error', (e) => {
this.sendMsg(this.$t('复制成功'))
})
},
goAuth(){
if(this.userInfo.id_auth==0){
this.$router.push('/pages/authentication')
}else  if(this.userInfo.id_auth==1){
this.sendMsg(this.$t("已提交身份认证"))
}else{
this.sendMsg(this.$t("您已完成身份认证"))
}
},
goAuth2(){
if(this.userInfo.id_toauth==0){
this.$router.push('/pages/advancedCtf')
}else  if(this.userInfo.id_toauth==1){
this.sendMsg(this.$t("已提交身份认证"))
}else{
this.sendMsg(this.$t("您已完成高级认证"))
}
},

getData(){
var that = this
this.$Loading()
getUserInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.userInfo = res.data

}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},
share(val) {
if (!val) {
return
}
navigator.clipboard.writeText(val).then(() => {
this.sendMsg(this.$t('复制成功'));
})
},

Logout(){
var that = this;
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定退出登录"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){

that.CLEAN_ALL()
window.localStorage.setItem("lang", that.lang || 'en')
window.localStorage.setItem("username", that.username)
window.localStorage.setItem("password", that.password)
that.$router.push('/pages/relogin')
}
})
},

},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/my.vue